import { render, staticRenderFns } from "./table-stats.vue?vue&type=template&id=6f032ad6&"
import script from "./table-stats.vue?vue&type=script&lang=js&"
export * from "./table-stats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../var/www/pulse/pulse_client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports